import { gql } from '@apollo/client';

// Note: recordCount cannot be accurate for this query, so preference only showing a page count
export const NOISE_EVENTS_HISTORY = gql(`
  query NoiseEventsHistory($filter: GetPagedNoiseEventsWithClassificationsFilters!, $paging: PagingInput!) {
    facility {
      noiseEvents (filter: $filter, paging: $paging) {
        previous
        next
        recordCount
        results {
          classifications {
            classificationId
            isAiClassified
            utcModifiedTime 
          }
          comments
          id
          disregarded
          leq
          leqMax
          lfMax
          sel
          locationId
          endTime
          startTime
          updatedTime
          weighting
          leqMaxTime
          noiseEventPolicyOverride {
            resourceGroupId
            override
          }
        }
      }
    }
  }
`);
